import React from "react";

// Minimal, dependency-free article text renderer.
// Blank line = new block. "## " / "### " headings, "- " bullets, "> " quotes, **bold**, [text](https://link).
const inline = (text) => {
  const parts = [];
  const re = /\*\*([^*]+)\*\*|\[([^\]]+)\]\((https?:\/\/[^)\s]+|\/[^)\s]*)\)/g;
  let last = 0; let m; let i = 0;
  while ((m = re.exec(text))) {
    if (m.index > last) parts.push(text.slice(last, m.index));
    if (m[1]) parts.push(<strong key={i++}>{m[1]}</strong>);
    else parts.push(<a key={i++} href={m[3]} className="text-[#264839] underline underline-offset-2 hover:text-[#B35C4A]" target={m[3].startsWith("http") ? "_blank" : undefined} rel="noreferrer">{m[2]}</a>);
    last = m.index + m[0].length;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts;
};

export function ArticleBody({ text, className = "" }) {
  const blocks = (text || "").replace(/\r\n/g, "\n").split(/\n{2,}/).map((b) => b.trim()).filter(Boolean);
  return (
    <div className={`space-y-5 ${className}`} data-testid="article-body">
      {blocks.map((block, idx) => {
        if (block.startsWith("### ")) return <h3 key={idx} className="font-serif text-xl md:text-2xl text-[#11211A] pt-2">{inline(block.slice(4))}</h3>;
        if (block.startsWith("## ")) return <h2 key={idx} className="font-serif text-2xl md:text-3xl text-[#11211A] pt-4">{inline(block.slice(3))}</h2>;
        if (block.startsWith("> ")) return <blockquote key={idx} className="border-l-4 border-[#B35C4A] pl-4 italic text-[#4A5550]">{inline(block.replace(/^> ?/gm, ""))}</blockquote>;
        const lines = block.split("\n");
        if (lines.every((l) => /^[-*] /.test(l))) {
          return <ul key={idx} className="list-disc pl-6 space-y-1.5 text-[#2B3A33]">{lines.map((l, j) => <li key={j}>{inline(l.replace(/^[-*] /, ""))}</li>)}</ul>;
        }
        if (lines.every((l) => /^\d+[.)] /.test(l))) {
          return <ol key={idx} className="list-decimal pl-6 space-y-1.5 text-[#2B3A33]">{lines.map((l, j) => <li key={j}>{inline(l.replace(/^\d+[.)] /, ""))}</li>)}</ol>;
        }
        return <p key={idx} className="text-[#2B3A33] leading-relaxed">{lines.map((l, j) => <React.Fragment key={j}>{j > 0 && <br />}{inline(l)}</React.Fragment>)}</p>;
      })}
    </div>
  );
}

export const formatArticleDate = (iso) => {
  if (!iso) return "";
  try { return new Date(iso).toLocaleDateString("en-AU", { day: "numeric", month: "long", year: "numeric" }); } catch { return iso.slice(0, 10); }
};
